<div class="more-green-choices-modal d-flex flex-column">
    <div class="close d-flex justify-content-end">
        <i class="btn-close icon-edponline-Bop-071" (click)="close()" aria-hidden="true"></i>
    </div>
    <img class="w-100 more-green-choices-modal-image" src="{{ image }}" alt="macro-challenge-image" />
    <div class="more-green-choices-modal-info">
        <h1 class="title">{{ "pt.edp.edponline.edpe.more.green.options.title" | translate }}</h1>
        <p class="description" [innerHTML]="'pt.edp.edponline.edpe.more.green.options.description' | translate"></p>
        <div class="container-button d-flex justify-content-center">
            <button class="btn btn-primary" type="button" (click)="close(true)">
                {{ "pt.edp.edponline.edpe.more.green.options.button" | translate }}
            </button>
        </div>
    </div>
</div>
